import { useState } from "react";

import { useShopcluesCategorySearchQuery } from "@/graphql/generated";

export interface ShopcluesCategoryOption {
  leafId: string;
  leafName: string;
  fullPath: string;
}

/**
 * Type-ahead search over the imported ShopClues category directory.
 * Fires only on an explicit search (Enter / Search button), not per keystroke.
 */
export function useShopcluesCategorySearch() {
  const [query, setQuery] = useState("");
  const [committedQuery, setCommittedQuery] = useState("");

  const { data, isLoading } = useShopcluesCategorySearchQuery(
    { input: { query: committedQuery } },
    { enabled: committedQuery.length >= 2 },
  );

  const results: ShopcluesCategoryOption[] =
    data?.shopcluesCategorySearch.categories ?? [];

  const search = () => {
    const trimmed = query.trim();
    if (trimmed.length < 2) return;
    setCommittedQuery(trimmed);
  };

  const clear = () => {
    setQuery("");
    setCommittedQuery("");
  };

  return { query, setQuery, committedQuery, search, clear, results, isLoading };
}
